import { render, staticRenderFns } from "./CreateDynamicRoute.vue?vue&type=template&id=534a7b88&"
import script from "./CreateDynamicRoute.vue?vue&type=script&lang=js&"
export * from "./CreateDynamicRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports